import React from 'react';
import { Alert, Typography } from '@mui/material';

export type EnrichmentPhaseInfo = {
  phase: string;
  label: string;
  description: string;
  allowed_buckets: string[];
  next_phase: string | null;
  env_var: string;
};

type Props = {
  phase?: EnrichmentPhaseInfo | null;
};

export const EnrichmentPhaseBanner: React.FC<Props> = ({ phase }) => {
  if (!phase) return null;

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        Enrichment pipeline phase: {phase.label}
      </Typography>
      <Typography variant="body2">{phase.description}</Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        Active buckets: {phase.allowed_buckets.join(', ')}.
        {phase.next_phase
          ? ` When this pass is done, set ${phase.env_var}=${phase.next_phase} and run npm run leads:queue:phase.`
          : ' Full-list enrichment is enabled.'}
      </Typography>
    </Alert>
  );
};

export default EnrichmentPhaseBanner;
